import { Header } from './Header';
import { Root } from './Root';
import { Footer } from './styled';
export const TabDialogLayout = {
    Root,
    Header,
    Footer,
};
